<div class="interface-control__client-intent-toggle__container" [bfx-input]="bfxInput">
  <div [ngClass]="inputDirective.labelClasses">{{data.label}}</div>
  <button
    pButton
    type="button"
    #intentValueButton
    (keyup)="handleKeyUpEvent($event)"
    (keydown)="handleKeyDownEvent($event)"
    (click)="handleIntentChange(!data.intentValue)"
    [label]="data.buttonLabel"
    [disabled]="locked"
    icon="bfx-icon icon-swap_horiz"
    iconPos="right"
    [ngClass]="{
      'bfx-button-oe-sell': data.intentValue,
      'bfx-button-oe-buy': !data.intentValue,
      'interface-control__client-intent-toggle__intent-button': true,
      'interface-control__client-intent-toggle__intent-button--sell': data.intentValue && !locked,
      'interface-control__client-intent-toggle__intent-button--buy': !data.intentValue && !locked,
      'interface-control__client-intent-toggle__intent-button--locked': locked
    }"
  ></button>
</div>
